import { LoginPage } from '@components-next/auth';

export default LoginPage;
